module.exports = __webpack_public_path__ + "img/IT在线就业班-课程大纲-学习路线-教学服务-博学谷-3.2c201a7d.png";